import { AddressInfo, AddressOption } from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

export class AddressManagerApi {
  loadAddresses(
    postcode: string,
    token: string,
    callback: (addresses: AddressOption[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const query = encodeURI(`?postcode=${postcode || ''}`);
    const dataUrl = '/api/addressmanager/addresses' + query;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      callback,
      failureCallback,
      signal
    );
  }

  loadAddress(
    moniker: string,
    token: string,
    callback: (foundAddress: AddressInfo) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/addressmanager/addresses/${moniker}`;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      callback,
      failureCallback,
      signal
    );
  }
}
